import { makeMoment, nextDay } from 'foundations-components/transitional/utils/SimpleDate';
import * as DateRangePresets from 'foundations-components/transitional/components/Dates';
export const getTimerangeFilter = ({
  property,
  startDate,
  endDate,
  presetId
}) => {
  let _startDate = startDate;
  let _endDate = endDate;
  if (presetId) {
    var _presetId;
    const preset = (_presetId = DateRangePresets[presetId]) === null || _presetId === void 0 ? void 0 : _presetId.getValue();
    if (preset) {
      _startDate = preset.startDate;
      _endDate = preset.endDate;
    }
  }
  const momentStartDate = _startDate ? makeMoment('portalTz', _startDate) : null;
  const momentEndDate = _endDate ? makeMoment('portalTz', nextDay(_endDate)) : null;
  if (momentStartDate && momentEndDate) {
    return {
      property,
      operator: 'BETWEEN',
      value: momentStartDate.valueOf(),
      highValue: momentEndDate.valueOf()
    };
  } else if (momentStartDate) {
    return {
      property,
      operator: 'GTE',
      value: momentStartDate.valueOf()
    };
  } else if (momentEndDate) {
    return {
      property,
      operator: 'LT',
      value: momentEndDate.valueOf()
    };
  }
  return null;
};
export const getEqFilter = ({
  property,
  value
}) => {
  return value && property ? {
    property,
    operator: 'EQ',
    value
  } : null;
};
export const getNeqFilter = ({
  property,
  value
}) => value && property ? {
  property,
  operator: 'NEQ',
  value
} : null;
export const getNotInFilter = ({
  property,
  values
}) => ({
  property,
  operator: 'NOT_IN',
  values
});